// extracted by mini-css-extract-plugin
export default {"gaugeCluster":"GaugeCluster_gaugeCluster__GXUYD","gaugeImage":"GaugeCluster_gaugeImage__aKh8S"};